import { render, staticRenderFns } from "./AIReefresh.vue?vue&type=template&id=61a438ca&scoped=true"
import script from "./AIReefresh.vue?vue&type=script&lang=js"
export * from "./AIReefresh.vue?vue&type=script&lang=js"
import style0 from "./AIReefresh.vue?vue&type=style&index=0&id=61a438ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a438ca",
  null
  
)

export default component.exports